import { engagementSegmentsSegmentIdCacheKey } from "@dashboardApi/apis/engagementSegmentsSegmentId/constants";

import type { AllRouteEndpoints } from "../routeTypes";
export const engagementSegmentsSegmentIdMigrateFiltersCacheKeys: AllRouteEndpoints[] = [
  engagementSegmentsSegmentIdCacheKey,
];
